module.exports = __webpack_public_path__ + "static/img/empty.abd8c06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/empty.png
// module id = 1jsv
// module chunks = 0